<template>
    <main>
        <pane-header
            :tools="tools"
            :title="tools.currentView.data.pane.title"
            :subtitle="tools.currentView.data.pane.sub"
            :hasBackButton="true"
            :appIconKey="tools.currentView.data.pane.type"
        />
        <pane-preview-container
            :tools="tools"
            :hideHeader="true"
        />
    </main>
</template>

<script>
    export default {
        name: 'pane-full-view',
        props: ['tools'],
    }
</script>



// WEBPACK FOOTER //
// PaneFullView.vue?af442aa4